import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=5b9d45c4&scoped=true"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=5b9d45c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d45c4",
  null
  
)

export default component.exports